var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"filter-dechets"},[_c('ul',{staticClass:"list_arbo mt-0"},_vm._l((_vm.$store.getters.getDechets),function(item,key){return _c('Arbo',{key:JSON.stringify(item),staticClass:"pt-0",attrs:{"initialItem":item,"initialShowCloseAll":true,"modelName":"ProjetDechetsInterface"}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }